// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-multiselect {
  display: flex;
  align-items: center;
  font-size: 14px;
  background-color: white;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid var(--primary-border-color);
  height: 40px;
}

.p-multiselect-close {
  display: none;
}

.p-multiselect-header {
  display: flex;
  align-items: center;
  gap: 24px;
  background-color: white;
}

.p-multiselect-panel {
  margin-top: 8px;
  box-shadow: var(--shadow-high);
  font-size: 14px;
}

.p-multiselect-filter-icon {
  right: 12px;
}

.p-multiselect-panel .p-multiselect-header {
  padding: 8px 12px;
  color: var(--primary-text-color);
  background: var(--primary-background-color);
}

.p-multiselect-items {
  background-color: white;
  padding: 8px 0;
}

.p-multiselect-item {
  padding: 8px 16px;
  gap: 8px;

  &:hover {
    background-color: var(--hover-primary-color);
  }

  &:focus-visible {
    outline: none;
  }
}

.p-checkbox-box {
  display: none;
}

.p-multiselect-select-all {
  display: none;
}

.p-multiselect-empty-message {
  padding: 8px 16px;
}

.p-placeholder {
  color: #757575;
}

.p-multiselect-label-container {
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/multi-select.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,QAAQ;;EAER;IACE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".p-multiselect {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  background-color: white;\n  padding: 12px;\n  border-radius: 4px;\n  border: 1px solid var(--primary-border-color);\n  height: 40px;\n}\n\n.p-multiselect-close {\n  display: none;\n}\n\n.p-multiselect-header {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  background-color: white;\n}\n\n.p-multiselect-panel {\n  margin-top: 8px;\n  box-shadow: var(--shadow-high);\n  font-size: 14px;\n}\n\n.p-multiselect-filter-icon {\n  right: 12px;\n}\n\n.p-multiselect-panel .p-multiselect-header {\n  padding: 8px 12px;\n  color: var(--primary-text-color);\n  background: var(--primary-background-color);\n}\n\n.p-multiselect-items {\n  background-color: white;\n  padding: 8px 0;\n}\n\n.p-multiselect-item {\n  padding: 8px 16px;\n  gap: 8px;\n\n  &:hover {\n    background-color: var(--hover-primary-color);\n  }\n\n  &:focus-visible {\n    outline: none;\n  }\n}\n\n.p-checkbox-box {\n  display: none;\n}\n\n.p-multiselect-select-all {\n  display: none;\n}\n\n.p-multiselect-empty-message {\n  padding: 8px 16px;\n}\n\n.p-placeholder {\n  color: #757575;\n}\n\n.p-multiselect-label-container {\n  width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
